import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../slices/Store";
import ProjectDetailConstructor from "./ProjectDetailConstructor";
import ProjectDetailViewConstructor from "./ProjectDetailViewConstructor";

export default function ProjectDetailConstructorSection() {
    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );
    const [showConstructorDetail, setShowConstructorDetail] = useState(false);

    useEffect(() => {
        setShowConstructorDetail(false);
    }, [projectDetailState.projectHashId]);

    return (
        <>
            <ProjectDetailViewConstructor
                visible={showConstructorDetail}
                onClick={() => setShowConstructorDetail(true)}
            />
            <ProjectDetailConstructor visible={showConstructorDetail} />
        </>
    );
}
